import { useTranslation } from "react-i18next";
import StockProductCard from "../StockProduct/StockProductCard";
import colorChartImageUrl from '@resources/img/items/stock_product-color-chart.jpg';

export default function ColorChart() {
  const [t] = useTranslation()

  return <StockProductCard
    stockProductSlug="color-chart"
    img={colorChartImageUrl}
    description={t('Our printed color charts will help you design your prints and be confident in the print color outcomes. The color chart features 784 color patches with the color numbers available in HEX, RGB, and CMYK color numbers. You can order your color chart on any of the fabrics we offer for on-demand printing.')}
  />
}
